// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { IButtonStyles, mergeStyles } from '@fluentui/react';

/**
 * @private
 */
export const videoCameraIconStyle = mergeStyles({
  marginRight: '0.375rem',
  fontSize: '1.375rem'
});

/**
 * @private
 */
export const buttonStyle = mergeStyles({
  fontWeight: 600,
  fontSize: '0.875rem',
  // 14px
  height: '2.75rem',
  width: '100%'
});

/**
 * @private
 */
export const buttonWithIconStyles: IButtonStyles = {
  textContainer: {
    display: 'contents'
  }
};